import * as React from "react";
import { useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { Button, Input, Typography, Form, Spin, message } from "antd";
import {
  LoadingOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";

import { AuthContext } from "../../context/AuthContext";

import "../../styles/Authentication.css";

const { Title, Text } = Typography;

const antIcon = (
  <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
);

const CreatePasswordPage: React.FC = () => {
  const { createPassword, loading, setLoading } = useContext(AuthContext);
  const { token } = useParams();

  const onFinish = (values: any) => {
    setLoading(true);
    createPassword(token, values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <div className="login-container">
        {/* Left Side */}
        <div className="login-left">
          <div className="login-header">
            <img
              src="/img/logo.png"
              alt="Life Cycle Logo"
              className="login-logo"
            />
            <Title
              level={2}
              style={{ color: "black", fontSize: 32, fontWeight: 400 }}
            >
              Create New Password
            </Title>
            <Text className="login-subtitle">
              Comprehensive Funeral Management.
            </Text>
          </div>

          {/* <Button icon={<GoogleOutlined />} block className="google-button">
            Sign in with Google
          </Button>

          <Divider plain className="login-divider">
            OR
          </Divider> */}

          <Form
            layout="vertical"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label={
                <Text style={{ fontWeight: 700, fontSize: 16 }}>Password</Text>
              }
              name="Password"
            >
              <Input.Password
                placeholder="**********"
                className="input-style"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item
              label={
                <Text style={{ fontWeight: 700, fontSize: 16 }}>
                  Confirm Password
                </Text>
              }
              name="ConfirmPassword"
            >
              <Input.Password
                placeholder="**********"
                className="input-style"
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <Link
                className="forgot-password"
                to="/"
                style={{
                  fontWeight: 700,
                  fontSize: 16,
                  color: "inherit",
                  textDecoration: "none",
                }}
              >
                Sign in?
              </Link>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                className="sign-in-button"
              >
                {loading ? <Spin indicator={antIcon} /> : <>Create Password</>}
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div className="login-right" />
      </div>
    </>
  );
};

export default CreatePasswordPage;
